<template>
  <div class="desc">
    <title-main :align="isMobile ? 'center' : 'left'">
      <slot name="title"/>
    </title-main>
    <h6 class="use-text-subtitle2" :class="[isMobile ? 'text-center' : 'text-left']">
      <slot name="text"/>
    </h6>
    <!--
    <div :class="[isMobile ? 'text-center' : 'text-left']">
      <v-btn color="primary" large class="btn">
        button
      </v-btn>
    </div>
    -->
  </div>
</template>

<script>
  import Title from '../Title'
  export default {
    name: "ColText",
    props: {
      orientation: {
        type: String,
        default: 'left'
      },
      isMobile: Boolean
    },
    components: {
      'title-main': Title
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/styles.scss';
  @import './feature-style.scss';
</style>